import React from 'react';
import { TCheapMoreShippingComponent } from '../types';
import { Container } from './styles';

export const CheapMoreShipping: TCheapMoreShippingComponent = ({ isLoading }) => (
  <Container $isLoading={isLoading}>
    <strong>frete mais barato</strong>&nbsp;na compra de mais unidades
  </Container>
);
